<template>
  <div
    class="default-layout"
    :style="isHomePage ? backgroundStyle : {}"
    :class="{
      'has-mobile-sticky-button': isLessonMaterialsPage,
      'home-page-background': isHomePage,
    }"
  >
    <AppHeader />
    <main class="main-content-layout">
      <router-view />
    </main>
    <AppFooter />
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";

const route = useRoute();
const isHomePage = computed(() => route.name === "HomePage");
const isLessonMaterialsPage = computed(
  () => route.name === "LessonMaterialsPage"
);
const backgroundStyle = {
  backgroundImage: "url('/images/background.svg')",
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
};
</script>

<style scoped>
.default-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.main-content-layout {
  flex: 1;
}

.home-page-background {
  background-position: top 0px right -600px;
}

/* Add padding only on mobile for lesson materials page to accommodate sticky button */
@media (max-width: 768px) {
  .default-layout.has-mobile-sticky-button {
    padding-bottom: 72px;
  }

  .home-page-background {
    background-position: top 0px right 350px; /* or right 350px top 0px */
  }
}
</style>
